import { createReducer, on } from '@ngrx/store';
import { PREPAYMENT_PLUGINS_USER_BALANCE_API_ACTIONS } from './prepayment.action';

export type PrepaymentUserBalancePluginState = Record<
  string,
  {
    isLoading: boolean;
    isLoaded: boolean;
    hasPrepaymentAccount: boolean;
    availableBalance: number | undefined;
    id: number | undefined;
  }
>;

export const PREPAYMENT_PLUGINS_USER_BALANCE_STORE_KEY = 'PrepaymentPluginsUserBalance';

export const PREPAYMENT_PLUGINS_USER_BALANCE_STORE_REDUCER = createReducer(
  {} as PrepaymentUserBalancePluginState,
  on(
    PREPAYMENT_PLUGINS_USER_BALANCE_API_ACTIONS.fetching,
    (state, { shopId }): PrepaymentUserBalancePluginState => {
      const result = {
        ...state,
        [shopId]: {
          ...state[shopId],
          isLoading: true,
        },
      };

      return result;
    },
  ),
  on(
    PREPAYMENT_PLUGINS_USER_BALANCE_API_ACTIONS.fetchingSuccess,
    (state, { available_balance, id, shopId }): PrepaymentUserBalancePluginState => {
      return {
        ...state,
        [shopId]: {
          ...state[shopId],
          isLoading: false,
          isLoaded: true,
          availableBalance: available_balance,
          hasPrepaymentAccount: true,
          id,
        },
      };
    },
  ),
  on(
    PREPAYMENT_PLUGINS_USER_BALANCE_API_ACTIONS.fetchingFailure,
    (state, { shopId }): PrepaymentUserBalancePluginState => {
      return {
        ...state,
        [shopId]: {
          ...state[shopId],
          isLoading: false,
          isLoaded: true,
          availableBalance: undefined,
          hasPrepaymentAccount: false,
          id: undefined,
        },
      };
    },
  ),
);
